import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { authHeader } from "../../../../../helpers";
import dateFormat from "dateformat";

const BookingFilesList = ({ bookingId }) => {
  const fileRef = useRef();
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ GET FILE LIST
  const fetchFiles = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_APIURL}booking/booking-files/${bookingId}`,
        {
          headers: authHeader()
        }
      );
      setFiles(res.data.files || []);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  useEffect(() => {
    if (bookingId) fetchFiles();
  }, [bookingId]);

  // ✅ Upload Files
  const handleChange = async (e) => {
    const selectedFiles = e.target.files;
    if (!selectedFiles.length) return;

    const formData = new FormData();

    for (let file of selectedFiles) {
      formData.append("files", file);
    }

    formData.append("id", bookingId); // 🔥 IMPORTANT

    try {
      setLoading(true);

      await axios.post(
        `${process.env.REACT_APP_APIURL}booking/upload-booking-files`,
        formData,
        {
          headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
        }
      );

      // ✅ Refresh list after upload
      fetchFiles();

    } catch (err) {
      console.error(err);
      alert("Upload failed");
    } finally {
      setLoading(false);
      e.target.value = null;
    }
  };

  // ✅ Delete File
  const handleDelete = async (fileId) => {
    if (!window.confirm("Are you sure you want to delete this file?")) return;

    try {
      await axios.delete(
        `${process.env.REACT_APP_APIURL}booking/delete-booking-file/${fileId}`,
        {
          headers: authHeader()
        }
      );

      // ✅ Refresh list after delete
      fetchFiles();

    } catch (err) {
      console.error(err);
      alert("Delete failed");
    }
  };

  return (
    <div className="d-card my-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">Documents</h4>

          <button
            className="btn btn-primary"
            onClick={() => fileRef.current.click()}
            disabled={loading}
          >
            {loading ? "Uploading..." : "Upload Files"}
          </button>

          <input
            type="file"
            multiple
            ref={fileRef}
            style={{ display: "none" }}
            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
            onChange={handleChange}
          />
    </div>
      {/* File List */}
      {files.map((file, i) => {
        const fileUrl = `${process.env.REACT_APP_APIURL}assets/uploads/kitDocuments/bookingFiles/${file.file_path}`;

        //const isImage = /\.(jpeg|jpg|png|gif|webp)$/i.test(file.file_path);

        return (
          <div
            key={file._id || i}
            className="mt-2"
            style={{
              border: "1px solid #ccc",
              padding: "10px",
              width: "100%",
              borderRadius: "6px"
            }}
          >
            {/* Preview */}
            <h4  className="mb-1">
               {file.file_name}
            </h4>
            <small>{dateFormat(file.createdAt, "dd-mm-yyyy HH:MM")} by {file.created_by?.first_name} {file.created_by?.last_name}</small>

            {/* Actions */}
            <div className="d-flex justify-content-end gap-2">
              <a
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary btn-sm"
                style={{minWidth:"50px"}}
              >
                <i className="fa fa-download"></i>
              </a>

              <button
                className="btn btn-danger btn-sm ml-2"
                onClick={() => handleDelete(file._id)}
                style={{minWidth:"50px"}}
              >
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BookingFilesList;